import { render, staticRenderFns } from "./space-rg.vue?vue&type=template&id=3337e068&"
import script from "./space-rg.vue?vue&type=script&lang=ts&"
export * from "./space-rg.vue?vue&type=script&lang=ts&"
import style0 from "./space-rg.vue?vue&type=style&index=0&lang=postcss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports